<template>
  <div>
    <v-toolbar
      :style="{
        zIndex: 1,
        borderTop: '1px solid',
        borderBottom: '1px solid',
        borderColor: '#ccc',
      }"
      height="80"
      card
      color="#fff"
    >
      <v-layout row align-center justify-space-between>
        <v-flex grow>
          <div
            class="mr-3"
            :style="{
              padding: '8px',
              display: 'inline-flex',
              backgroundColor: '#ef565c',
              borderRadius: '0.5rem',
            }"
          >
            <v-icon color="white">directions_bus</v-icon>
          </div>
          <h1 style="display: inline">Transporte Escolar</h1>
        </v-flex>
      </v-layout>
      <v-speed-dial
        v-if="
          userPermissions[possibleUserModulePermissions.CREATE_TRANSPORT_ROUTE]
        "
        absolute
        bottom
        left
        direction="bottom"
        open-on-hover
        transition="scale-transition"
        style="bottom: 0"
      >
        <template v-slot:activator>
          <v-tooltip right>
            <router-link slot="activator" :to="{ name: 'createRoute' }">
              <v-btn style="z-index: 99" color="gradiente" dark small fab>
                <v-icon style="width: 100%">add</v-icon>
              </v-btn>
            </router-link>
            <span>Crear nueva ruta</span>
          </v-tooltip>
        </template>
      </v-speed-dial>
    </v-toolbar>
    <v-container
      fluid
      grid-list-xl
      style="padding: 20px; height: 90vh; overflow: scroll"
    >
      <v-layout row wrap>
        <v-flex xs12 style="padding: 0 12px 10px">
          <v-card flat class="border-container">
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 sm4 md3>
                  <v-text-field
                    label="Buscar"
                    class="border-container"
                    prepend-inner-icon="search"
                    clearable
                    solo
                    flat
                    hide-details
                    v-model="filters.search"
                    @keyup.enter="getItems"
                    @click:clear="clearSearch"
                  >
                  </v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 style="padding: 0 12px 10px">
          <v-card flat class="border-container">
            <v-card-text class="px-0 py-0">
              <v-data-table
                :rows-per-page-items="[25, 50, 100]"
                :headers="headers"
                :items="items"
                :total-items="totalItems"
                :loading="isLoadingTable"
                :expand="expanded"
                :pagination.sync="pagination"
                @update:pagination="getItems"
                must-sort
                no-data-text="No hay rutas creadas"
                no-results-text="No hay resultados"
              >
                <template v-slot:headers="props">
                  <tr>
                    <td v-for="header in props.headers">
                      {{ header.text }}
                    </td>
                  </tr>
                </template>
                <template v-slot:items="props">
                  <tr class="body-2 font-weight-regular">
                    <td>{{ props.item.name }}</td>
                    <td
                      v-if="props.item.drivers.length > 0"
                      :class="props.item.id == colapSel ? 'little-green' : ''"
                      @click="expandProps(props)"
                    >
                      <v-btn icon>
                        <v-badge color="green">
                          <template v-slot:badge>
                            <span>{{ props.item.drivers.length }}</span>
                          </template>
                          <v-icon class="no-border">
                            {{
                              !props.item.drivers.length
                                ? 'person_outline'
                                : props.item.drivers.length == 1
                                ? 'person'
                                : 'group'
                            }}
                          </v-icon>
                        </v-badge>
                      </v-btn>
                    </td>
                    <td
                      v-else
                      @click="
                        () => {
                          modals.showCollabs = true
                          modals.idRoute = props.item.id
                        }
                      "
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn v-on="on" flat icon>
                            <v-icon color="red" class="no-border">
                              person_add
                            </v-icon>
                          </v-btn>
                        </template>
                        Agregar chofer
                      </v-tooltip>
                    </td>
                    <td>
                      {{ props.item.studentCount }}
                    </td>
                    <td>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            v-on="on"
                            @click="detailTransportationRoute(props.item.id)"
                          >
                            <v-icon class="gray--text">visibility</v-icon>
                          </v-btn>
                        </template>
                        <span>Ver detalle</span>
                      </v-tooltip>
                    </td>
                    <td>
                      <DropDownOptions>
                        <v-list>
                          <v-list-tile
                            :disabled="
                              !userPermissions[
                                possibleUserModulePermissions
                                  .UPDATE_TRANSPORT_ROUTE
                              ]
                            "
                            @click="editTransportationRoute(props.item.id)"
                          >
                            <v-list-tile-action>
                              <v-icon>edit</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                              <v-list-tile-title>Editar</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                          <v-divider></v-divider>
                          <v-list-tile
                            :disabled="
                              !userPermissions[
                                possibleUserModulePermissions
                                  .CREATE_TRANSPORT_ROUTE
                              ]
                            "
                            @click="cloneTransportationRoute(props.item.id)"
                          >
                            <v-list-tile-action>
                              <v-icon>content_copy</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                              <v-list-tile-title>Duplicar</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                          <v-divider></v-divider>
                          <v-list-tile
                            :disabled="
                              !userPermissions[
                                possibleUserModulePermissions
                                  .DELETE_TRANSPORT_ROUTE
                              ]
                            "
                            @click="showDeleteConfirm(props.item.id, 'route')"
                          >
                            <v-list-tile-action>
                              <v-icon>delete</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                              <v-list-tile-title>Eliminar</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </v-list>
                      </DropDownOptions>
                    </td>
                  </tr>
                </template>
                <template v-slot:expand="props">
                  <v-container text-xs-center>
                    <v-layout row wrap style="margin-left: calc(100% - 812px)">
                      <v-toolbar color="white" class="elevation-0" height="40">
                        <v-layout flex xs12 md11>
                          <v-expand-transition class>
                            <div
                              class="no-padding"
                              xs12
                              sm3
                              xl4
                              style="margin-top: 10px"
                            >
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                    v-on="on"
                                    flat
                                    fab
                                    small
                                    @click="
                                      showDeleteConfirm(props.item.id, 'driver')
                                    "
                                    :disabled="
                                      selected.length === 0 ||
                                      !userPermissions[
                                        possibleUserModulePermissions
                                          .UPDATE_TRANSPORT_ROUTE
                                      ]
                                    "
                                  >
                                    <v-icon color="primary">delete</v-icon>
                                  </v-btn>
                                </template>
                                Eliminar chofer
                              </v-tooltip>
                            </div>
                          </v-expand-transition>
                        </v-layout>
                      </v-toolbar>
                      <v-container
                        style="max-height: 75vh"
                        class="scrollDesign"
                      >
                        <v-layout row wrap>
                          <v-flex ma-1 xs12 class="expandableContainer">
                            <v-data-table
                              :items="props.item.drivers"
                              :expand="expanded"
                              must-sort
                              style="max-height: 18vh; overflow-y: scroll"
                              v-model="selected"
                              hide-actions
                              item-key="id"
                              select-all
                            >
                              <template v-slot:headers="props">
                                <tr>
                                  <th style="width: 70px; max-width: 70px">
                                    <v-checkbox
                                      :input-value="props.all"
                                      :indeterminate="props.indeterminate"
                                      primary
                                      color="primary"
                                      hide-details
                                      @click.stop="toggleAll"
                                    />
                                  </th>
                                  <th style="width: 70px">Foto</th>
                                  <th>Nombre</th>
                                  <th>Apellidos</th>
                                  <th style="width: 260px">Correo</th>
                                  <th>Rol</th>
                                </tr>
                              </template>
                              <template v-slot:items="props">
                                <td style="width: 70px; max-width: 70px">
                                  <v-checkbox
                                    color="primary"
                                    v-model="props.selected"
                                    primary
                                    hide-details
                                  />
                                </td>
                                <td style="width: 70px">
                                  <span>
                                    <v-icon
                                      v-if="
                                        props.item.imageStorage == undefined ||
                                        props.item.imageStorage.miniObjUrl ==
                                          undefined
                                      "
                                    >
                                      account_circle
                                    </v-icon>
                                    <v-avatar
                                      v-else
                                      size="30"
                                      color="grey lighten-4"
                                    >
                                      <img
                                        :src="
                                          props.item.imageStorage.miniObjUrl
                                        "
                                      />
                                    </v-avatar>
                                  </span>
                                </td>
                                <td>
                                  <CustomTooltipOverflowText>
                                    {{ props.item.firstName }}
                                  </CustomTooltipOverflowText>
                                </td>
                                <td>
                                  <CustomTooltipOverflowText>
                                    {{ props.item.lastName }}
                                  </CustomTooltipOverflowText>
                                </td>
                                <td style="width: 260px">
                                  <CustomTooltipOverflowText>
                                    {{ props.item.email }}
                                  </CustomTooltipOverflowText>
                                </td>
                                <td>
                                  {{ props.item.role }}
                                </td>
                              </template>
                            </v-data-table>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-layout>
                  </v-container>
                </template>
                <v-progress-linear
                  v-slot:progress
                  color="primary"
                  indeterminate
                ></v-progress-linear>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <ConfirmDelete
      :show="modals.showDelete"
      :title="modals.confirmDeleteModalTitle"
      cancel-text="No, Cancelar"
      ok-text="Sí, Eliminar"
      @change="onConfirmDelete"
    >
      <p>
        {{ modals.confirmDeleteModalDescription }}
      </p>
    </ConfirmDelete>
    <ConfirmAddCollab
      :show="modals.showConfirmAddCollabs"
      title="¿Seguro que deseas añadir este colaborador a esta ruta?"
      cancel-text="No, Cancelar"
      ok-text="Sí, Añadir"
      @change="onConfirmAddCollab"
    />
    <ResponseDialog
      v-model="modals.deleteResponseShow"
      :loading="modals.deleteResponseLoading"
      :is-error="modals.deleteResponseIsError"
      :message="modals.deleteResponseMessage"
      :auto-close="true"
    />
    <CollaboratorsModal
      v-model="modals.showCollabs"
      :allow-many="false"
      @close="onCloseCollabs"
      @save="onSaveCollabs"
    />
    <Loading v-model="modals.loading" text="Cargando..." />
    <Error v-model="modals.showError" :text="modals.errorMessage" />
    <Success v-model="modals.showSuccess" text="Chofer agregado con éxito" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { _getUserPermissions } from '../../../../utils/genericUtils.js'
import Error from '../../../Dialogs/Error.vue'
import Loading from '../../../Dialogs/Loading.vue'
import Success from '../../../Dialogs/Success.vue'
import {
  default as ConfirmAddCollab,
  default as ConfirmDelete,
} from '../../../Dialogs/confirm_new_ui.vue'
import DropDownOptions from '../../../dropDown/options.vue'
import CustomTooltipOverflowText from '../../../generic/custom_tooltip_overflow_text.vue'
import ResponseDialog from '../Authorizations/responseDialog.vue'
import CollaboratorsModal from './components/collaboratorsModal.vue'

export default {
  components: {
    CustomTooltipOverflowText,
    DropDownOptions,
    ConfirmDelete,
    ConfirmAddCollab,
    ResponseDialog,
    CollaboratorsModal,
    Error,
    Loading,
    Success,
  },
  data() {
    return {
      userPermissions: {},
      possibleUserModulePermissions: {
        CREATE_TRANSPORT_ROUTE: 'CREATE_TRANSPORT_ROUTE',
        UPDATE_TRANSPORT_ROUTE: 'UPDATE_TRANSPORT_ROUTE',
        DELETE_TRANSPORT_ROUTE: 'DELETE_TRANSPORT_ROUTE',
      },
      tempPropExpanded: {},
      copyTempExpandedItems: [],
      selected: [],
      expanded: false,
      filters: {
        search: '',
      },
      totalItems: 0,
      headers: [
        {
          text: 'Nombre',
          value: 'name',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Chofer responsable',
          value: 'driver',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Alumnos',
          value: 'students',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Ver detalle',
          value: 'detail',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Acción',
          value: 'action',
          sortable: false,
          align: 'center',
        },
      ],
      items: [],
      isLoadingTable: false,
      pagination: {
        page: 1,
        rowsPerPage: 25,
      },
      modals: {
        showSuccess: false,
        loading: false,
        showError: false,
        showCollabs: false,
        showConfirmAddCollabs: false,
        addCollabs: [],
        idRoute: undefined,
        errorMessage: '',
        showDelete: false,
        deleteResponseShow: false,
        deleteResponseLoading: false,
        deleteResponseMessage: false,
        deleteResponseIsError: false,
        deleteId: undefined,
        confirmDeleteModalTitle: '',
        confirmDeleteModalDescription: '',
        /**
         * @type {'driver'|'route'}
         */
        deleteType: undefined,
      },
    }
  },
  mounted() {
    this.getItems()
    if (this.getUser != null && this.getUser.id) {
      this.mapPermits()
    }
  },
  methods: {
    closeCurrentExpanded() {
      this.tempPropExpanded.expanded = false
    },
    expandProps(props) {
      props.expanded = !props.expanded
      this.tempPropExpanded = props
      this.copyTempExpandedItems = structuredClone(props.item.drivers)
    },
    toggleAll() {
      if (this.selected.length) this.selected = []
      else this.selected = this.copyTempExpandedItems.slice()
    },
    async onConfirmDelete(e) {
      this.modals.showDelete = false

      if (e === false) return
      this.modals.deleteResponseShow = true
      this.modals.deleteResponseLoading = true
      if (this.modals.deleteType === 'driver') {
        try {
          await this.$store.dispatch(
            'transport/removeDriverRoute',
            this.modals.deleteId
          )
          this.modals.deleteResponseIsError = false
          this.modals.deleteResponseMessage = 'Chofer eliminado con éxito.'
        } catch (error) {
          console.log(error)
          const customErrors = {
            404: 'No se encontró la ruta.',
            409: 'La ruta está actualmente en uso.',
          }

          this.modals.deleteResponseIsError = true
          this.modals.deleteResponseMessage = customErrors[
            error.response.status
          ]
            ? customErrors[error.response.status]
            : 'Error al eliminar el chofer'
        } finally {
          this.modals.deleteResponseLoading = false
          this.modals.deleteId = undefined
          this.closeCurrentExpanded()
          this.getItems()
        }
      }
      if (this.modals.deleteType === 'route') {
        try {
          await this.$store.dispatch(
            'transport/removeRoute',
            this.modals.deleteId
          )
          this.modals.deleteResponseIsError = false
          this.modals.deleteResponseMessage = 'Ruta eliminada con éxito.'
        } catch (error) {
          console.log(error)
          const customErrors = {
            404: 'No se encontró la ruta.',
            409: 'La ruta está actualmente en uso.',
          }

          this.modals.deleteResponseIsError = true
          this.modals.deleteResponseMessage = customErrors[
            error.response.status
          ]
            ? customErrors[error.response.status]
            : 'Error al eliminar la ruta'
        } finally {
          this.modals.deleteResponseLoading = false
          this.modals.deleteId = undefined
          this.getItems()
        }
      }
    },
    detailTransportationRoute(id) {
      this.$router.push({
        name: 'detailRoute',
        params: { id },
      })
    },
    editTransportationRoute(id) {
      this.$router.push({
        name: 'editRoute',
        params: { id },
      })
    },
    async cloneTransportationRoute(idRoute) {
      try {
        await this.$store.dispatch('transport/cloneRoute', idRoute)
        await this.getItems()
      } catch (error) {
        console.log(error)
      }
    },
    /**
     * @param {number} id
     * @param {'driver'|'route'} deleteType
     */
    showDeleteConfirm(id, deleteType) {
      this.modals.showDelete = true
      this.modals.deleteId = id
      this.modals.deleteType = deleteType

      if (deleteType === 'driver') {
        this.modals.confirmDeleteModalTitle =
          '¿Estas seguro que deseas eliminar el colaborador de la ruta?'
        this.modals.confirmDeleteModalDescription =
          'Una vez eliminado el colaborador, ya no se mostrará esta ruta en su aplicación.'
      }

      if (deleteType === 'route') {
        this.modals.confirmDeleteModalTitle =
          '¿Seguro que desea eliminar este transporte escolar?'
        this.modals.confirmDeleteModalDescription =
          'Al eliminarlo, ya no se le mostrará más al chofer del transporte'
      }
    },
    clearSearch() {
      this.filters.search = ''
      this.getItems()
    },
    async getItems() {
      try {
        this.isLoadingTable = true
        const { data } = await this.$store.dispatch('transport/getRoutes', {
          size: this.pagination.rowsPerPage,
          offset: (this.pagination.page - 1) * this.pagination.rowsPerPage,
          search: this.filters.search,
        })

        // MAKE SINGLE DRIVER AN ARRAY OF DRIVERS REMOVE ONCE IT'S MADE FROM BACK
        const temp = data.data.map((e) => ({
          ...e,
          drivers: [e.collaborator].filter((e) => Boolean(e)),
        }))

        this.items = temp
        this.totalItems = data.total
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoadingTable = false
      }
    },
    onCloseCollabs() {
      this.modals.showCollabs = false
    },
    onSaveCollabs(collabs) {
      this.modals.showConfirmAddCollabs = true
      this.modals.addCollabs = collabs
    },
    async onConfirmAddCollab(e) {
      if (e === false) {
        this.modals.showConfirmAddCollabs = false
        return
      }

      this.modals.loading = true

      try {
        await this.$store.dispatch('transport/addCollabToRoute', {
          idRoute: this.modals.idRoute,
          data: {
            value: this.modals.addCollabs[0].id,
          },
        })
        this.modals.showSuccess = true
        await this.getItems()
      } catch (error) {
        console.log(error)
        const customErrors = {
          404: 'No se encontró la ruta.',
          409: 'La ruta está actualmente en uso.',
        }

        this.modals.showError = true
        this.modals.errorMessage = customErrors[error.response.status]
          ? customErrors[error.response.status]
          : 'Error al agregar chofer'
      } finally {
        this.modals.loading = false
        this.modals.showConfirmAddCollabs = false
        this.modals.showCollabs = false
        // VALUE CHANGED FROM COMPONENT
        // this.modals.showSuccess = false
      }
    },
    mapPermits() {
      this.userPermissions = _getUserPermissions({
        getUser: this.getUser,
        possibleUserModulePermissions: this.possibleUserModulePermissions,
      })
    },
  },
  watch: {
    getUser() {
      this.mapPermits()
    },
  },
  computed: {
    ...mapGetters(['getUser']),
  },
}
</script>
<style scoped>
.border-container {
  border: 1px solid;
  border-color: #ccc !important;
  border-radius: 0.5rem;
  overflow: hidden;
}

.icon-select {
  padding: 8px;
}

::v-deep .v-input__prepend-outer {
  margin-right: -1px !important;
}

::v-deep .padded .v-input__slot {
  padding-left: 8px !important;
}

::v-deep .v-datatable.v-table > thead {
  display: table;
  width: 100%;
  table-layout: fixed;
}

table.v-table > thead tr {
  background-color: #dddddd;
  background-color: #f9fafb;
  height: 40px;
}
::v-deep .v-datatable.v-table > thead tr {
  background-color: #dddddd;
  text-transform: initial !important;
  color: #6b7280;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  white-space: nowrap;
}

::v-deep .v-datatable.v-table > tbody {
  max-height: 50vh;
  min-height: 50vh;
}
::v-deep .v-datatable.v-table > tbody tr td {
  text-align: center;
  font-size: inherit;
  font-weight: inherit;
}
::v-deep .v-datatable.v-table > tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

@media (max-width: 600px) {
  ::v-deep .v-datatable.v-table > thead {
    display: block;
  }
}
.expandableContainer {
  border-style: solid;
  border-color: #e6e6e6;
  border-radius: 15px;
  border-width: 2px;
}

::v-deep .table-full .v-datatable.v-table > tbody {
  max-height: calc(106vh - 426px);
  min-height: calc(106vh - 426px);
}

.expandableContainer ::v-deep .v-datatable.v-table > tbody {
  max-height: initial !important;
  min-height: initial !important;
}
</style>
